<div class="full-screen-dialog create-app-dialog">
  <button class="floating-close-button" [mat-dialog-close]>
    <svg-icon-sprite style="color:white;" [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'24px'">
    </svg-icon-sprite>
  </button>
  <h1 class="create-app-title" mat-dialog-title>Onboard new App</h1>
  <mat-dialog-content>
    <div class="" *ngIf="false">
      <form novalidate [formGroup]="createAppForm" (ngSubmit)="onCreateAppSubmit()">
        <mat-form-field appearance="outline" class="col-lg-4 p-0 mr-5" [hideRequiredMarker]="true">
          <input matInput [type]="'text'" formControlName="appName" placeholder="App Name">
          <mat-error
            *ngIf="createAppForm.get('appName').hasError('invalidDcName') && createAppForm.controls['appName'].touched">
            Only numbers (0-9), letters(a-z, A-Z), "_" and "-" characters are allowed as part of app name
          </mat-error>
          <mat-error
            *ngIf="createAppForm.get('appName').hasError('invalidValue') && createAppForm.controls['appName'].touched">
            App Name is invalid
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-4 p-0" [hideRequiredMarker]="true">
          <mat-select placeholder="Platform" formControlName="appType">
            <ng-container *ngFor="let appType of scopeData.appTypes">
              <mat-option *ngIf="!appType.hidden" appDisableFeature
                [pathString]="'account_settings.' + appType.parentFeature + '.' + appType.featureName"
                [value]="appType.value" [disabled]="trialUserData.istrialUser && ['be'].indexOf(appType.value) !== -1">
                {{appType.name}}
                <ng-container *ngIf="trialUserData.istrialUser">
                  <div class="d-inline-block trial-user-server" *ngIf="appType.value === 'be'">PREMIUM</div>
                </ng-container>
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>

        <div class="clearfix"></div>

        <mat-form-field appearance="outline" class="col-lg-4 p-0 mr-5" [hideRequiredMarker]="true"
          *ngIf="showDomainField()">
          <input matInput [type]="'text'" formControlName="appDomain" placeholder="Domain">
          <mat-error
            *ngIf="createAppForm.get('appDomain').hasError('invalidDomain') && createAppForm.controls['appDomain'].touched">
            Invalid Domain
          </mat-error>
          <mat-hint>
            Enter your web domain to integrate with Netcore Product Experience (Eg - If your website is
            “www.example.com” or
            “www.docs.example.com”,
            only enter “example.com”) <br><br>
            To use Netcore Product Experience on multiple websites such as “example.com”, “example.us”, “example.de”,
            only enter
            “example”
            in the field
            above.
            <i style="font-size:14px" class="material-icons align-middle"
              matTooltip="To use Netcore Product Experience on any website, enter '*'. Please note that this will significantly lower security as this will let any website run Netcore Product Experience with your app details"
              [matTooltipPosition]="'below'">
              info
            </i>
          </mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-4 p-0 mr-5" [hideRequiredMarker]="true"
          *ngIf="showAppCustomUrlField()">
          <input matInput [type]="'text'" formControlName="appCustomUrl" placeholder="Custom URL Scheme Identifier">
          <mat-error
            *ngIf="createAppForm.get('appCustomUrl').hasError('invalidCustomUrl') && createAppForm.controls['appCustomUrl'].touched">
            Custom Url is invalid
          </mat-error>
          <mat-hint>
            You will be unable to add test devices without defining the Custom URL Scheme. You can change this value
            later from the app settings page.
            <br><br>
            Please learn more about adding the Custom URL scheme <a class="link link-btn"
              href="https://developer.apple.com/documentation/xcode/allowing_apps_and_websites_to_link_to_your_content/defining_a_custom_url_scheme_for_your_app"
              target="_blank">here</a>.
          </mat-hint>
        </mat-form-field>

        <div class="clearfix"></div>
        <button class="primary-btn text-uppercase mt-5" mat-flat-button color="primary"
          [disabled]="isFormValid()">Create</button>

      </form>
    </div>
    <div class="header">
      Please contact your account manager.
    </div>
  </mat-dialog-content>
</div>
